import { type FilterState } from '@calendar/components/calendar-filters';
import { CalendarDaysIcon, ListIcon, StarIcon } from 'lucide-react';
import { getConfiguredSeason, getSeasonOptions } from '@calendar/lib/season';

export const DEFAULT_FILTERS: FilterState = {
  season: getConfiguredSeason(),
  month: null,
  category: undefined,
  livestreamOnly: false,
  ticketedOnly: false,
  upcomingOnly: true,
  sortBy: 'date-asc',
  view: 'featured',
};

// Seasons
export const SEASONS = getSeasonOptions();

// Academic seasons with their corresponding months
export const ACADEMIC_MONTHS = [
  { id: 'jan', name: 'JAN' },
  { id: 'feb', name: 'FEB' },
  { id: 'mar', name: 'MAR' },
  { id: 'apr', name: 'APR' },
  { id: 'may', name: 'MAY' },
  { id: 'jun', name: 'JUN' },
  { id: 'jul', name: 'JUL' },
  { id: 'aug', name: 'AUG' },
  { id: 'sep', name: 'SEP' },
  { id: 'oct', name: 'OCT' },
  { id: 'nov', name: 'NOV' },
  { id: 'dec', name: 'DEC' },
];

// Views
export const VIEWS = [
  { id: 'featured', name: 'Featured', icon: StarIcon },
  { id: 'list', name: 'List', icon: ListIcon },
  { id: 'grid', name: 'Calendar', icon: CalendarDaysIcon },
];

export const URL_PARAM_KEYS = {
  season: 'season',
  month: 'month',
  category: 'category',
  upcomingOnly: 'upcoming',
  livestreamOnly: 'livestream',
  ticketedOnly: 'ticketed',
  sortBy: 'sort',
  view: 'view',
} as const;
